var _excluded = ["EventName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { getMixpanel } from '@domain-group/fe-helper';
import { getDeviceType } from '@domain-group/fe-brary';
import retrieveUserToken from '../utils/user-token';
var safeWindow = (typeof window === 'undefined' ? {} : window) || {};
var firstRun = true;
export default _ref => {
  var _ref$activeExperiment = _ref.activeExperiments,
    activeExperiments = _ref$activeExperiment === void 0 ? [] : _ref$activeExperiment;
  return (_ref2, globalData) => {
    var _globalData$user;
    var EventName = _ref2.EventName,
      data = _objectWithoutProperties(_ref2, _excluded);
    var metaData = _objectSpread({
      loggedIn: (globalData === null || globalData === void 0 ? void 0 : (_globalData$user = globalData.user) === null || _globalData$user === void 0 ? void 0 : _globalData$user.type) === 'authenticated',
      sessionToken: retrieveUserToken(),
      deviceCategory: safeWindow.screen ? getDeviceType(safeWindow.screen.width) : 'unknown'
    }, data);
    var mixpanel = getMixpanel();
    if (mixpanel) {
      // This will run '$experiment_started' once per page load.
      // No idea if this is the right thing to do, but it's a start
      if (firstRun) {
        firstRun = false;
        activeExperiments.forEach(_ref3 => {
          var name = _ref3.name,
            variant = _ref3.variant;
          mixpanel.track('$experiment_started', {
            name,
            variant
          });
        });
      }
      mixpanel.track(EventName, metaData);
    }
  };
};